import { FC, SVGAttributes } from 'react';

const MoneyBag: FC<React.PropsWithChildren<React.PropsWithChildren<SVGAttributes<SVGElement>>>> = ({ ...props }) => {
  return (
    <svg width="61" height="60" viewBox="0 0 61 60" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.4999 15.5267C36.7131 15.5267 41.7499 10.8139 41.7499 5.00032C41.7499 5.00014 41.7497 5 41.7496 5H19.2502C19.25 5 19.2499 5.00014 19.2499 5.00032C19.2499 10.8139 24.2867 15.5267 30.4999 15.5267Z"
        fill="#F8C200"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.3687 21.9031C52.3335 24.2289 53 27.3149 53 30.3595V43.0526C53 45.9304 52.3778 48.8228 50.546 51.0422C48.1859 53.9019 44.4046 55 40.6968 55H20.3028C16.5951 55 12.814 53.9019 10.454 51.0424C8.62217 48.823 8 45.9307 8 43.0529V30.3594C8 27.3147 8.6665 24.2285 10.6315 21.9028C15.2673 16.4157 22.4441 12.8945 30.4999 12.8945C38.5559 12.8945 45.7328 16.4158 50.3687 21.9031Z"
        fill="#FFD70F"
      />
      <path
        d="M44.5625 31.7491H41.75L43.3906 26.0532H39.0417L37.7135 31.7491H34.4323L32.974 26.0532H28.2604L26.8281 31.7491H23.5208L22.1927 26.0532H17.6094L19.25 31.7491H16.4375V34.8457H20.1354L22.9219 44.4744H27.2188L30.5 31.7265L33.7812 44.4744H38.0781L40.8646 34.8457H44.5625V31.7491ZM24.25 34.8457H26.0208L25.1094 38.4847L24.25 34.8457ZM36.151 38.5525L35.2135 34.8457H37.0104L36.151 38.5525Z"
        fill="white"
      />
    </svg>
  );
};

export default MoneyBag;
